// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"language-selector__container___KfEWK","button":"language-selector__button___1bWlc"};
    if(module.hot) {
      // 1631577387499
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  